import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const patientDetailSlice = createSlice({
    name: 'patientDetailSlice',
    initialState: {
        patientDetailTab: "summary"
    },
    reducers: {
        setPatientDetailTab: (state, action: PayloadAction<string>) => {
            state.patientDetailTab = action.payload;
        },
        setPatientDetailTabDefault: (state) => {
            state.patientDetailTab =  "summary";
        },
    },
});

export const { setPatientDetailTab, setPatientDetailTabDefault } = patientDetailSlice.actions;
export default patientDetailSlice.reducer;
